import React from "react";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";

import { Progress } from "../Progress";
import { EnhancedTableBody } from "../EnhancedTableBody";
import { TABLE_ROW_HEIGHT } from "../../constants/styles";
import { usePaginationTableContext } from "../PaginatedTable/context";

import { IProps } from "./types";

const getTableRowStyle = (rows: number) => ({ height: TABLE_ROW_HEIGHT * rows });

export const PaginatedTableBody: React.FC<IProps> = (props) => {
  const { colSpan, isLoading, isFetchMoreLoading, emptyRows, rows } = usePaginationTableContext();

  return (
    <EnhancedTableBody {...props} colSpan={colSpan + 2} isLoading={isLoading}>
      {props.children}
      {isFetchMoreLoading && (
        <TableRow style={getTableRowStyle(1)}>
          <TableCell align="center" colSpan={colSpan + 2}>
            <Progress type="linear" />
          </TableCell>
        </TableRow>
      )}
      {Boolean(rows.length) && emptyRows > 0 && (
        <TableRow style={getTableRowStyle(emptyRows)}>
          <TableCell colSpan={colSpan + 2} />
        </TableRow>
      )}
    </EnhancedTableBody>
  );
};
